import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import routesArray from "./routes";
import {uuid} from "@/helpers";
import {  ApiService } from '@/api/api';
import store from "@/store";

import { useGtag } from "vue-gtag-next"

const routes: Array<RouteRecordRaw> = routesArray;
const { event } = useGtag()

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {

  

  let DeviceID =localStorage.getItem('DeviceID')

  if(DeviceID == null){
    
    DeviceID = uuid();
    


    const RequestParam = {
      "activity": "generatedevicid",
      "deviceid": DeviceID
    }

    const RequestResp = await ApiService.SaveUserActivity(RequestParam)
    event('apirequest', { 'event_category' : 'generatedevicid',    })
    const {data}  = RequestResp 
    if(data.result == 'complete'){
      localStorage.setItem('DeviceID',DeviceID)
      store.dispatch('logs/SetDeviceID',DeviceID)
    }
  }


  

  if(from.name =='Result' && to.name =='play'){
    next('/')
  }
  // console.log(from.name)

  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  next();
});

export default router
